<div style="    background: #051b39;text-align: center;">
    <img src="assets/images/comingsoon.jpg" alt="Comingsoon" style="max-width: 100%; margin: auto;object-fit: cover;">
</div>